import { createBrowserHistory } from 'history';

export default {
  DASHBOARD: '/',
  SIGN_IN: '/sign-in',
  SIGN_UP: '/sign-up',
  PROJECTS: {
    LIST: '/projects/',
    CREATE: '/projects/create',
    EDIT: '/projects/:id/edit',
  },
  PROJECT: {
    MAIN: '/project/:id',
    INFO: '/project/:id/info',
    SURVEYS: '/project/:id/surveys',
    SURVEYS_INVITE: '/project/:id/collect-data/manual/invite/:uuid',
    SURVEYS_SEND_INVITES: '/project/:id/collect-data/manual/send/:uuid',
    REPORTS: '/project/:id/reports',
    FILES: '/project/:id/files',
    EDIT: '/project/:id/review',
    COLLECT_DATA: '/project/:id/collect-data',
    COLLECT_DATA_MANUAL: '/project/:id/collect-data/manual',
    COLLECT_DATA_EMAIL: '/project/:id/collect-data/email',
    COLLECT_DATA_CSV: '/project/:id/collect-data/csv',
    COLLECT_DATA_LINK: '/project/:id/collect-data/link',
    COLLECT_DATA_AUTOMATIC: '/project/:id/collect-data/automatic',
    COLLECT_DATA_STATISTICS: '/project/:id/statistics',
    SUBSCRIPTIONS: '/project/:id/subscriptions',
    TEMPLATE: {
      MAIN: '/project/:id/collect-data/template',
      CREATE_EMAIL: '/project/:id/collect-data/template-email/create',
      EDIT_EMAIL: '/project/:id/collect-data/template-email/edit/:templateId',
      CREATE_REMINDER: '/project/:id/collect-data/template-reminder/create',
      EDIT_REMINDER:
        '/project/:id/collect-data/template-reminder/edit/:templateId',
    },
    SHARED_REPORT_PUBLIC:
      '/org/:organizationId/shared-report-links/:linkId/public',
    SHARED_REPORT_PRIVATE:
      '/org/:organizationId/shared-report-links/:linkId/password_protected',
  },
  SETTINGS: {
    MAIN: '/settings',
    PROFILE: '/settings/profile',
    EMAIL: '/settings/email',
    PASSWORD: '/settings/password',
    ORGANIZATION: '/settings/organization',
    BEXIO: '/settings/bexio',
  },
  ORGANIZATION: {
    INVITE_USER: '/organization/:codename/:organizationId/users/invite',
    PRODUCTS: '/organization/:codename/products/:product_slug',
    ADMIN: {
      USERS: '/organization/users',
      USER_SHARED: '/organization/users/:id/shared',
      GROUPS: '/organization/groups',
      GROUP_SHARED: '/organization/groups/:id/shared',
      PROJECTS: '/organization/projects',
      PROJECT_SHARED: '/organization/projects/:id/shared',
      PRODUCTS: '/organization/products',
      PRODUCTS_SHARED: '/organization/products/:id/shared',
    },
  },
  RECOVER_PASSWORD: '/recover',
  SET_PASSWORD: '/password-reset/:key',
  CONFIRM_INVITE: '/invite/:organization_name/:key',
  CONFIRM_EMAIL: '/account/confirm/:confirmationKey',
  SIGN_OUT: '/sign-out',
  ADMIN: {
    ORGANIZATIONS: {
      LIST: '/admin/organizations',
      SINGLE: '/admin/organizations/:id',
      PROJECTS: '/admin/organizations/:codename/projects',
      USERS: '/admin/organizations/:codename/users',
      USER: '/admin/organizations/:codename/users/:uuid',
      CREDITS: '/admin/organizations/:id/credits',
      INVITE_USER:
        '/admin/organizations/:codename/:organizationId/users/invite',
      INVITATIONS_USER: '/admin/organizations/:codename/users/invitations',
      PROJECT: {
        INFO: '/admin/organizations/:codename/projects/:id/info',
        REPORTS: '/admin/organizations/:codename/projects/:id/reports',
        PROGRESS: '/admin/organizations/:codename/projects/:id/statistics',
        FILES: '/admin/organizations/:codename/projects/:id/files',
        SURVEYS: '/admin/organizations/:codename/projects/:id/surveys',
        SURVEYS_INVITE:
          '/admin/organizations/:codename/projects/:id/collect-data/manual/invite/:uuid',
        SURVEYS_SEND_INVITES:
          '/admin/organizations/:codename/projects/:id/collect-data/manual/send/:uuid',
        EDIT: '/admin/organizations/:codename/projects/:id/review',
        COLLECT_DATA:
          '/admin/organizations/:codename/projects/:id/collect-data',
        COLLECT_DATA_MANUAL:
          '/admin/organizations/:codename/projects/:id/collect-data/manual',
        COLLECT_DATA_AUTOMATIC:
          '/admin/organizations/:codename/projects/:id/collect-data/automatic',
        COLLECT_DATA_STATISTICS:
          '/admin/organizations/:codename/projects/:id/statistics',
        COLLECT_DATA_EMAIL:
          '/admin/organizations/:codename/projects/:id/collect-data/email',
        COLLECT_DATA_CSV:
          '/admin/organizations/:codename/projects/:id/collect-data/csv',
        COLLECT_DATA_LINK:
          '/admin/organizations/:codename/projects/:id/collect-data/link',
        SUBSCRIPTIONS:
          '/admin/organizations/:codename/projects/:id/subscriptions',
        TEMPLATE: {
          MAIN: '/admin/organizations/:codename/projects/:id/collect-data/template',
          CREATE_EMAIL:
            '/admin/organizations/:codename/projects/:id/collect-data/template-email/create',
          EDIT_EMAIL:
            '/admin/organizations/:codename/projects/:id/collect-data/template-email/edit/:templateId',
          CREATE_REMINDER:
            '/admin/organizations/:codename/projects/:id/collect-data/template-reminder/create',
          EDIT_REMINDER:
            '/admin/organizations/:codename/projects/:id/collect-data/template-reminder/edit/:templateId',
        },
      },
    },
    TEMPLATES: {
      BRIEFINGS: {
        MAIN: '/admin/templates/briefings',
        CREATE: '/admin/templates/briefings/create',
        EDIT: '/admin/templates/briefings/:id/edit',
      },
      SURVEYS: {
        MAIN: '/admin/templates/surveys',
        CREATE: '/admin/templates/surveys/create',
        EDIT: '/admin/templates/surveys/:id/edit',
      },
    },
    PRODUCTS: {
      LIST: '/admin/products',
      SINGLE: '/admin/products/:slug',
      CREATE: '/admin/products/create',
    },
    WORKBENCHES: {
      LIST: '/admin/workbenches',
      SINGLE: '/admin/workbenches/:id',
      CREATE: '/admin/workbenches/create',
    },
    USERS: {
      LIST: '/admin/users',
      SINGLE: '/admin/users/:uuid',
    },
    ASSETS: {
      LIST: '/admin/assets',
    },
  },

  WORKBENCH: {
    INNOVATION: '/workbench/innovation',
    EXPERIENCE: '/workbench/experience',
    BRANDING: '/workbench/branding',
  },
  PRODUCTS: {
    UNAUTHORIZED: '/products/:product_slug',
    BRIEFING: '/briefings/:id',
  },
  NOTIFICATIONS: '/notification',
  PAYMENTS: {
    MAIN: '/payments',
    FAILED_PAYMENT: '/payment/failure',
    SUCCESS_PAYMENT: '/payment/success',
    ORDER_HISTORY: '/payments/order-history',
    CREDIT_CARD_INFO: '/payments/credit-card-info',
    INVOICE_INFO: '/payments/invoice-info',
  },
  BEXIO: {
    VERIFY: '/organization/:codename/bexio-login',
  },
};

export const history = createBrowserHistory();
